<template>
  <div class="sidebar__wrapper">
    <component
      v-for="setting in sidebarComponentSettings"
      :key="setting.id"
      :is="setting.component"
      :class="setting.className"
    />
  </div>
</template>

<script>
import LiveBytes from './LiveBytes'
import SidebarTopBrokers from './SidebarTopBrokers'
import SidebarBannerTop from './SidebarBannerTop'
import SidebarBannerMiddle from './SidebarBannerMiddle'
import SidebarBannerStartTrading from './SidebarBannerStartTrading'
import SidebarMustRead from './SidebarMustRead'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'
import { getSidebarComponentSettings } from '@/plugins/helper'

export default {
  name: 'ASidebar',
  components: {
    LiveBytes,
    SidebarTopBrokers,
    SidebarBannerTop,
    SidebarBannerMiddle,
    SidebarMustRead,
    PremiumBanner: hydrateWhenVisible(() =>
      import('@/components/_layout/ASidebar/PremiumBanner')
    ),
    SidebarBannerStartTrading
  },
  computed: {
    sidebarComponentSettings() {
      return getSidebarComponentSettings(this.$route.name)
    }
  }
}
</script>

<style lang="scss">
.sidebar__wrapper {
  height: 100%;
}
</style>
